import { HERO_VIEW } from '../../../shared/constants/heroView.js'

export function resolveHeroView(requestedView, currentView, heroCapabilities) {
  const availableViews = heroCapabilities?.availableViews ?? []

  if (availableViews.includes(requestedView)) return requestedView

  const fallbackModelView = availableViews.includes(HERO_VIEW.SITE)
    ? HERO_VIEW.SITE
    : availableViews.includes(HERO_VIEW.BUILDING)
    ? HERO_VIEW.BUILDING
    : null

  if ((requestedView === HERO_VIEW.SITE || requestedView === HERO_VIEW.BUILDING) && fallbackModelView) {
    return fallbackModelView
  }

  if (availableViews.includes(currentView)) return currentView
  if (availableViews.includes(heroCapabilities?.initialView)) return heroCapabilities.initialView

  return availableViews[0] ?? heroCapabilities?.initialView ?? HERO_VIEW.SITE
}

export function resolveHeroBuildingId(targetView, activeBuilding, buildings, preferredBuildingId = null) {
  if (targetView !== HERO_VIEW.BUILDING) return activeBuilding ?? null
  if (preferredBuildingId) return preferredBuildingId
  if (activeBuilding) return activeBuilding
  return buildings?.[0]?.id_cad ?? null
}
